<div class="global-overlay-page">
  @if (code) {
  <div style="width:100%;">
    <h3>{{clientName}}</h3>
    <app-code-detail [code]="code" (close)="closeCodeDetail($event)"></app-code-detail>
  </div>
  }



  <div [hidden]="code" style="display: flex; justify-content: center; padding: 20px">
    <div style="width: 100%;margin-top: 20px;line-height:2rem;">
      <div style="display: flex">
        <input type="text" (keyup)="filter($event)" placeholder="Filter" />
      </div>

      <mat-table #table [dataSource]="loading ? [] : dataSource" matSort>
        @for (column of columnNames; track column) {
        <ng-container matColumnDef="{{ column.id }}">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ column.value }}</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element[column.id] }}</mat-cell>
        </ng-container>
        }


        <ng-container matColumnDef="editCode">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element"><a (click)="editCode(element.clientid, element.code)">Edit
              code</a></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      @if (loading) {
      <div class="skeleton-container">
        @for (row of skeletonRows; track $index) {
        <div class="skeleton-row-flex">
          @for (weight of row; track $index) {
          <div class="skeleton-bar" [style.flex-grow]="weight"></div>
          }
        </div>
        }
      </div>
      }

      <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>